if (!customElements.get('delivery-times')) {
  customElements.define(
    'delivery-times',
    class DeliveryTimes extends HTMLElement {
      constructor(){
        super();
        this.updateDates();
        if(this.closest('details')){
          this.closest('details').addEventListener(() => {
            this.updateDates()
          }).bind(this)
        }
      }

      updateDates(){
        var compare_date = new Date()
        var w_d = 0, standard_min_date, standard_max_date, express_min_date, express_max_date
        const working_days = this.dataset.workingDays.split(",").map(elem=> parseInt(elem, 10));
        const holidays = [];
        this.querySelectorAll('holiday-date').forEach( (element) => {
          holidays.push(new Date(element.innerText))
        })

        if(compare_date.getHours() < this.cutoff){w_d += 1;}
        dayLoop: for(var i=0; i<100; i++){
          compare_date.setDate(compare_date.getDate()+1);
          for(var h=0; h<holidays.length; h++){
            if(holidays[h].getDate() == compare_date.getDate() && holidays[h].getMonth() == compare_date.getMonth() && holidays[h].getYear() == compare_date.getYear()) {
              continue dayLoop;
            }
          }
          if(working_days.includes(parseInt(compare_date.getDay()))) {w_d += 1;} else {continue dayLoop;}
          
          if(w_d == this.standardMin) {standard_min_date = new Date(compare_date)}
          if(w_d == this.expressMin) {express_min_date = new Date(compare_date)}
          if(w_d == this.expressMax) {express_max_date = new Date(compare_date)}
          if(w_d == this.standardMax){
            {standard_max_date = new Date(compare_date)}
            break
          }
        }          
        
        this.querySelectorAll('delivery-message.standard-production').forEach((element) => {
          element.querySelector('span[data-type="min"]').innerText = this.day(standard_min_date.getDay()) + " " + standard_min_date.getDate() + this.ord(standard_min_date.getDate()) + " " + this.mnth(standard_min_date.getMonth())
          element.querySelector('span[data-type="max"]').innerText = this.day(standard_max_date.getDay()) + " " + standard_max_date.getDate() + this.ord(standard_max_date.getDate()) + " " + this.mnth(standard_max_date.getMonth())
        })
        this.querySelectorAll('delivery-message.express-production').forEach((element) => {
          if (element.querySelector('span[data-type="min"]')) element.querySelector('span[data-type="min"]').innerText = this.day(express_min_date.getDay()) + " " + express_min_date.getDate() + this.ord(express_min_date.getDate()) + " " + this.mnth(express_min_date.getMonth())
          if (element.querySelector('span[data-type="max"]')) element.querySelector('span[data-type="max"]').innerText = this.day(express_max_date.getDay()) + " " + express_max_date.getDate() + this.ord(express_max_date.getDate()) + " " + this.mnth(express_max_date.getMonth())
        })
      }

      mnth(month){
        const mnths = ['January','February','March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
        return mnths[month]
      }

      day(day){
        const dow = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
        return dow[day]
      }

      ord(date){
        switch (parseInt(date)){
          case 1:
            return 'st'
          case 2:
            return 'nd'
          case 3:
            return 'rd'
          case 21:
            return 'st'
          case 22:
            return 'nd'
          case 23:
            return 'rd'
          case 31:
            return 'st'
          default:
            return 'th'
        }
      }

      get standardMin () {
        return parseInt(this.dataset.standardDaysMin)
      }

      get standardMax () {
        return parseInt(this.dataset.standardDaysMax)
      }

      get expressMin () {
        return parseInt(this.dataset.expressDaysMin)
      }

      get expressMax () {
        return parseInt(this.dataset.expressDaysMax)
      }

      get cutoff () {
        return parseInt(this.dataset.cutoffTime)
      }
    }
  )
}